import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext, Home } from '@mui/icons-material';
import MaidPortalLayout from '../components/maid-portal/MaidPortalLayout';
import JobExecutionScreen from '../components/maid-portal/JobExecutionScreen';

const MaidJobDetailPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();

  return (
    <MaidPortalLayout>
      <Box mb={2}>
        <Breadcrumbs separator={<NavigateNext fontSize="small" />}>
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate('/maid-portal')}
            sx={{ display: 'flex', alignItems: 'center', gap: 0.5, textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}
          >
            <Home fontSize="small" />
            My Schedule
          </Link>
          <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 500 }}>
            Job Detail
          </Typography>
        </Breadcrumbs>
      </Box>
      <JobExecutionScreen
        jobId={jobId}
        onJobComplete={() => navigate('/maid-portal')}
      />
    </MaidPortalLayout>
  );
};

export default MaidJobDetailPage;
